<template>
  <div style="height: 100%; overflow: scroll; padding-bottom: 10rem">
    <div v-if="!editNews">
      <div class="container">
        <div class="row hd">
          <div class="col-4 text-left">Title</div>
          <div class="col-1 text-left">Author</div>
          <div class="col-3 text-left">Tags</div>
          <div class="col-2 text-left">Date</div>
          <div class="col-2 text-left">Action</div>
        </div>
        <div
          :key="index"
          v-for="(news, index) in news_all"
          class="row"
          style="padding: 1rem; border-bottom: 1px solid #ecedfb"
        >
          <div class="col-4 text-left" style="color: #166bff">
            <span
              style="cursor: pointer"
              @click="getThisNews(news.lookup_id)"
              >{{ news.news_title }}</span
            >
          </div>
          <div class="col-1 text-left">{{ news.news_author }}</div>
          <div class="col-3 text-left">
            <span :key="i" v-for="(tags, i) in news.news_tags">{{
              tags + ", "
            }}</span>
          </div>
          <div class="col-2 text-left">
            {{
              new Date(
                new Date(news.post_timestamp).toISOString()
              ).toLocaleDateString()
            }}
          </div>
          <div class="col-2 text-left">
            <span
              @click="deleteNews(news.lookup_id)"
              style="
                color: var(--button-delete-color);
                cursor: pointer;
                margin-right: 2rem;
              "
              >Delete</span
            >
            <span
              @click="editThisNews(news)"
              style="color: var(--button-color); cursor: pointer"
              >Edit</span
            >
          </div>
        </div>
      </div>
      <div v-if="super_admin">
        <div class="vertical-gap"></div>
        <div v-if="news_not_approved.length > 0" class="container">
          <div class="row hd">
            <div class="col-4 text-left">Title</div>
            <div class="col-1 text-left">Author</div>
            <div class="col-3 text-left">Tags</div>
            <div class="col-2 text-left">Date</div>
          </div>
          <div
            :key="index"
            v-for="(news, index) in news_not_approved"
            class="row"
            style="padding: 1rem; border-bottom: 1px solid #ecedfb"
          >
            <div class="col-4 text-left" style="color: #166bff">
              <span
                style="cursor: pointer"
                @click="getThisNews(news.lookup_id)"
                >{{ news.news_title }}</span
              >
            </div>
            <div class="col-1 text-left">{{ news.news_author }}</div>
            <div class="col-3 text-left">
              <span :key="i" v-for="(tags, i) in news.news_tags">{{
                tags + ", "
              }}</span>
            </div>
            <div class="col-2 text-left">
              {{
                new Date(
                  new Date(news.post_timestamp).toISOString()
                ).toLocaleDateString()
              }}
            </div>
            <div class="col-2 text-left">
              <span
                @click="approveNews(news.lookup_id)"
                style="
                  color: var(--button-color);
                  cursor: pointer;
                  margin-right: 2rem;
                "
                >Approve</span
              >
            </div>
          </div>
        </div>
        <div class="vertical-gap"></div>
        <div v-if="news_approved.length > 0" class="container">
          <div class="row hd">
            <div class="col-6 text-left">Title (Approved)</div>
            <div class="col-1 text-left">Author</div>
            <div class="col-3 text-left">Tags</div>
            <div class="col-2 text-left">Date</div>
          </div>
          <div
            :key="index"
            v-for="(news, index) in news_approved"
            class="row"
            style="padding: 1rem; border-bottom: 1px solid #ecedfb"
          >
            <div class="col-6 text-left" style="color: #166bff">
              <span
                style="cursor: pointer"
                @click="getThisNews(news.lookup_id)"
                >{{ news.news_title }}</span
              >
            </div>
            <div class="col-1 text-left">{{ news.news_author }}</div>
            <div class="col-3 text-left">
              <span :key="i" v-for="(tags, i) in news.news_tags">{{
                tags + ", "
              }}</span>
            </div>
            <div class="col-2 text-left">
              {{
                new Date(
                  new Date(news.post_timestamp).toISOString()
                ).toLocaleDateString()
              }}
            </div>
          </div>
        </div>
      </div>
      <div v-if="news_single">
        <v-dialog max-width="100.0rem" v-model="dialog">
          <div style="position:relative;padding:2rem 2rem 0 2rem ;background-color:white">
            <v-icon
            @click="closeDialog"
            class="icon-class-reject"
            style="float: right"
            >mdi-close</v-icon
          >
          <news-single-view
            :key="news_single.lookup_id"
            v-bind:newsObj="news_single"
            :hidesave="true"
          ></news-single-view>
          </div>
        </v-dialog>
      </div>
    </div>
    <div v-else>
      <edit-news
        v-on:cancel="cancelNews"
        v-bind:news="editableNews"
        v-on:posted="newsposted"
      ></edit-news>
    </div>
  </div>
</template>

<script>
import {
  APPROVE_NEWS_ADMIN,
  DELETE_NEWS_ADMIN,
  GET_NEWS_ADMIN,
  GET_NEWS_SUPER_ADMIN,
} from "../../../Api/admin_api";
import NewsSingleView from "../../admin/News/news-single-view";
import EditNews from "../../admin/News/edit-news";
export default {
  name: "manage-news",
  components: {
    NewsSingleView,
    EditNews,
  },
  data: function () {
    return {
      dialog: false,
      news_all: [],
      news_single: {},
      news_approved: [],
      news_not_approved: [],
      super_admin: false,
      editNews: false,
      editableNews: {},
    };
  },
  methods: {
    newsposted(){
        this.Checkpermission();
        this.cancelNews();
    },
    cancelNews() {
      const self = this;
      self.editableNews = {};
      self.editNews = false;
    },
    closeDialog() {
      const self = this;
      self.news_single = {};
      self.dialog = false;
    },
    getNews() {
      const self = this;
      GET_NEWS_ADMIN()
        .then(function (response) {
          if (response.status === 200) {
            self.news_all = response.data.news;
          }
        })
        .catch();
    },
    getNewsApprove() {
      const self = this;
      let params = {
        status: 3,
      };
      GET_NEWS_SUPER_ADMIN(params)
        .then(function (response) {
          if (response.status === 200) {
            self.news_approved = response.data.news;
          }
        })
        .catch();
    },
    getNewsNotApprove() {
      const self = this;
      let params = {
        status: 1,
      };
      GET_NEWS_SUPER_ADMIN(params)
        .then(function (response) {
          if (response.status === 200) {
           
            self.news_not_approved = response.data.news;
          }
        })
        .catch();
    },
    getThisNews(id) {
      const self = this;
      let params = {
        lookup_id: id,
      };
      GET_NEWS_ADMIN(params)
        .then(function (response) {
          if (response.status === 200) {
        
            self.news_single = response.data;
            self.dialog = true;
          }
        })
        .catch();
    },
    editThisNews(news) {
      const self = this;
      self.editableNews = news;
      self.editNews = true;
    },
    approveNews(id) {
      // const self = this;
      let data = {
        lookup_id: id,
      };
      APPROVE_NEWS_ADMIN(data)
        .then(function () {
          window.location.reload();
        })
        .catch(function () {
          window.location.reload();
        });
    },
    deleteNews(id) {
      // const self = this;
      let data = {
        lookup_id: id,
      };
      DELETE_NEWS_ADMIN(data)
        .then(function () {
          // window.location.reload()
        })
        .catch(function () {
          // window.location.reload()
        });
    },
    Checkpermission() {
      const self = this;
      let info = JSON.parse(localStorage.getItem("user"));
      self.super_admin = !!info.super_admin;
      if (self.super_admin) {
        self.getNewsApprove();
        self.getNewsNotApprove();
        self.getNews();
      } else {
        self.getNews();
      }
    },
  },
  mounted() {
    this.Checkpermission();
  },
};
</script>

<style scoped>
.hd {
  background-color: #f2f3f8;
  color: #000000;
  padding: 1rem;
}
</style>
